import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap } from 'rxjs/operators';

import * as actions from '@appStore/managers/actions';
import { ManagerCompanyInvitationActionTypes, ManagerCompanyInvitationsLoadData } from '@appStore/managers/actions';
import { ManagerService } from '@appStore/managers/services';
import { Router } from '@angular/router';

@Injectable()
export class ManagerUserInvitationEffects {
  constructor(private managerService: ManagerService, private actions$: Actions, private router: Router) {}

  createManagerCompanyInvitations$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ManagerCompanyInvitationActionTypes.BulkCreateManagerCompanyInvitations),
      map((action: actions.BulkCreateManagerCompanyInvitations) => action.payload),
      exhaustMap(invitations =>
        this.managerService.bulkCreateManagerCompanyInvitations(invitations).pipe(
          map(items => new actions.BulkCreateManagerCompanyInvitationsSuccess(items)),
          catchError(error => of(new actions.BulkCreateManagerCompanyInvitationsFail(error)))
        )
      )
    );
  });

  loadManagerCompanyInvitations$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ManagerCompanyInvitationActionTypes.ManagerCompanyInvitationsLoadData),
      exhaustMap((action: ManagerCompanyInvitationsLoadData) => {
        return this.managerService.getMyManagerCompanyInvitations(action.payload).pipe(
          map(invitations => new actions.ManagerCompanyInvitationsLoadSuccess(invitations)),
          catchError(error => of(new actions.ManagerCompanyInvitationsLoadFail(error)))
        );
      })
    );
  });

  removeManagerCompanyInvitation$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ManagerCompanyInvitationActionTypes.ManagerCompanyInvitationRemove),
      map((action: actions.ManagerCompanyInvitationRemove) => action.payload),
      exhaustMap(invitation =>
        this.managerService.removeManagerCompanyInvitation(invitation).pipe(
          map(() => new actions.ManagerCompanyInvitationRemoveSuccess(invitation)),
          catchError(error => of(new actions.ManagerCompanyInvitationRemoveFail(error)))
        )
      )
    );
  });
  
  reSendManagerCompanyInvitation$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ManagerCompanyInvitationActionTypes.ManagerCompanyInvitationReSend),
      map((action: actions.ManagerCompanyInvitationReSend) => action.payload),
      exhaustMap(invitation =>
        this.managerService.reSendManagerCompanyInvitation(invitation).pipe(
          map(items => new actions.ManagerCompanyInvitationReSendSuccess(items)),
          catchError(error => of(new actions.ManagerCompanyInvitationReSendFail(error)))
        )
      )
    );
  });
}
